module.exports = __webpack_public_path__ + "dad71ea302b09b8b94ea36d202a494f0.svg";